var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "radio-button-container no-highlight",
      class: _vm.containerClasses,
      attrs: {
        role: "radio",
        tabindex: _vm.isTabbable,
        "aria-label": _vm.ariaLabel
      },
      on: {
        click: _vm.click,
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.click($event)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "radio-button--circle", class: _vm.activeClass },
        [
          _c("BaseIcon", {
            staticClass: "radio-button--icon circle-icon",
            attrs: { icon: "circle" }
          }),
          _vm._v(" "),
          _c("BaseIcon", {
            staticClass: "radio-button--icon check-icon",
            attrs: {
              isCustom: true,
              icon: "radioButtonSelected",
              fill: false,
              size: "1x"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "option-choice-name", class: _vm.activeClass }, [
        _vm._v("\n            " + _vm._s(_vm.name) + "\n        ")
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d80cd76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d80cd76","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseRadio.vue
// module id = null
// module chunks = 